import React, { useState } from 'react';
import axios from 'axios';
import A1 from '../Login/Chatbot.jpeg';

const EmRegistration = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmitEmail = async () => {
        if (!email) {
            console.log("this is email",email)
            setMessage("Please enter a valid email.");
            return;
        }
        try {
            const response = await axios.post('https://botapi.emedha.in/auth/api/api/submit-emaill', { email });
            if (response.data.success) {
                setMessage("Thank you for registering. Please wait for admin approval. Once approved, you will receive a registration link via email.");
            } else {
                setMessage("There was an error submitting your email.");
            }
        } catch (error) {
            setMessage("Error submitting email. Please try again.");
        }
    };

    return (
        <div className="container-fluid min-vh-100 d-flex justify-content-center align-items-center bg-light">
            <div className="card shadow-lg p-4 rounded" style={{ maxWidth: '500px', width: '100%' }}>
                <div className="text-center mb-4">
                    <img src={A1} alt="ChatBot Services" style={{ width: '150px' }} />
                    <h2 className="fw-bold text-primary"> Emedha ChatBot <span className="text-success">Services</span></h2>
                    <p className="text-muted">Welcome back! 👋</p>
                    <p>Please sign in to access your account.</p>
                </div>
                <h3 className="mb-3 text-center">Email Registration</h3>

                <div className="form-group mb-3">
                    <input type="email" className="form-control form-control-lg" placeholder="Enter your email" value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>

                <div className="text-center">
                    <button className="btn btn-primary btn-lg w-100" onClick={handleSubmitEmail}>Submit</button>
                </div>

                {message && (<div className={`mt-3 alert ${message.includes("Error") ? "alert-danger" : "alert-info"}`} role="alert">{message}</div>)}
            </div>
        </div>
    );
};

export default EmRegistration;
